<template>
  <div>
    <div class="custom_3">
        <div class="custom3_title">{{newsObj.title}}</div>
        <div class="custom3_describe_text">{{newsObj.describeText}}</div>
        <div class="custom3_see" @click="seePre">查看处方详情</div>
    </div>
   
  </div>
</template>
<script>
export default {
  props: {
    payload: {
      type: Object,
      required: true
    }

  },
    data(){
        return {
            newsObj :{},
            imgList:[]
        }
    },
    methods:{
      seePre(){
        alert("查看处方详情")
      },



    },
    mounted(){
      // console.log(this.payload)
      this.newsObj = JSON.parse(this.payload.data).data||{}
    //  console.log(this.newsObj)
       

        
    }

};
</script>
<style lang="scss" scoped>
.custom_3 {
    .custom2_title{
        font-weight: bold;
        margin-bottom: 10px;
    }

    .custom2_reason{
        color: red;
    }
    .custom3_see{
        color: #FEA57A;
        text-align: center;
        border-top: 1px solid #e2e2e2;
        margin-top: 10px;
        padding-top: 5px;
        cursor: pointer;
    }
}
</style>